import { Rv } from '../../components'
import { ContactForm } from './ContactForm'

const RESUME_PATH     = '/Devamkumar_Patel_Resume.pdf'
const RESUME_FILENAME = 'Devamkumar_Patel_Resume.pdf'

export function ContactSection() {
  return (
    <section id="contact" className="sec">
      <div className="wrap">
        <Rv>
          <div className="ci">
            <div className="slb" style={{ justifyContent: 'center' }}>Contact</div>
            <h2 className="st" style={{ textAlign: 'center' }}>Let&apos;s Build Together</h2>
            <div className="gbar" style={{ margin: '.9rem auto 0' }}/>

            <p className="ss" style={{ marginTop: '1.2rem' }}>
              Seeking a Software Developer, QA Engineer, or IT Graduate role.
              Open to opportunities where reliable, scalable systems matter.
            </p>
            <p className="ss" style={{ marginTop: '.3rem', fontFamily: 'var(--mono)', fontSize: '.78rem' }}>
              Clayton, VIC 3168 · +61 0426 208 912
            </p>

            {/* ── CTA buttons ── */}
            <div className="cbtns">
              <a href="https://www.linkedin.com/in/devampatel2501" target="_blank" rel="noopener" className="btn bp">
                LinkedIn →
              </a>
              <a href="mailto:devampatel1101@gmail.com" className="btn bg-btn">
                Send Email
              </a>
              <a
                href={RESUME_PATH}
                download={RESUME_FILENAME}
                className="btn resume-btn"
                aria-label="Download resume PDF"
              >
                <span className="resume-icon">⬇</span> Resume
              </a>
            </div>

            <ContactForm/>
          </div>
        </Rv>
      </div>
    </section>
  )
}
